const DashboardTooltips = {
    accuracyIndex: 'The accuracy index represents how closely your responses align with the correct answers in the quiz.\nIt indicates the precision of your knowledge and understanding',
    time: 'Time represents the duration it took to complete the category',
    current: '',
    history: '',
}

export default DashboardTooltips